










































import { Component, Model, Prop, Vue } from "vue-property-decorator";
import BenchmarkSettings from "./BenchmarkSettings.vue";
import LongTrendFilterForm from "@/components/diagnostics/LongTrendFilterForm.vue";

@Component({
  components: {
    BenchmarkSettings,
    LongTrendFilterForm
  }
})
export default class ComparisonActions extends Vue {
  @Model("update:modelValue") benchmark!: number;
  @Prop({ default: false }) filterSelect!: boolean;
  @Prop() trendName!: string;

  isBenchmarkOpen: boolean = false;
  isFiltersOpen: boolean = false;

  get isFilterVisible() {
    return this.trendName === "ShipSpeedDev";
  }

  onBenchmarkUpdate(benchmark: number) {
    this.$emit("update:modelValue", benchmark);
  }
}
